"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.topicNeedsHelpfulMark = exports.mostLikedCommentId = exports.orderTopicComments = exports.commentLikeCount = exports.buildCommentThreads = exports.canAuthorSoftDeleteComment = exports.canAuthorEditComment = exports.isCommentSoftDeleted = exports.isCommentModerated = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var forumsLimits_1 = require("./forumsLimits");
var isCommentModerated = function (comment) {
    return Boolean(comment.moderator && comment.reasonForModeration);
};
exports.isCommentModerated = isCommentModerated;
var isCommentSoftDeleted = function (comment) {
    return Boolean(comment.deletedAt);
};
exports.isCommentSoftDeleted = isCommentSoftDeleted;
var resolveCommentAuthorId = function (author) {
    if (typeof author === 'string')
        return author;
    if (author && typeof author === 'object' && '_id' in author) {
        var id = author._id;
        if (typeof id === 'string')
            return id;
        if (id && typeof id === 'object' && 'toString' in id) {
            return String(id.toString());
        }
    }
    return '';
};
var canAuthorEditComment = function (comment, authorId, editWindowHours) {
    if (editWindowHours === void 0) { editWindowHours = forumsLimits_1.DEFAULT_FORUMS_COMMENT_EDIT_WINDOW_HOURS; }
    if ((0, exports.isCommentModerated)(comment) || (0, exports.isCommentSoftDeleted)(comment))
        return false;
    var commentAuthorId = resolveCommentAuthorId(comment.author);
    if (commentAuthorId !== authorId)
        return false;
    if (!comment.createdAt)
        return false;
    var deadline = (0, dayjs_1.default)(comment.createdAt).add(editWindowHours, 'hour');
    return (0, dayjs_1.default)().isBefore(deadline);
};
exports.canAuthorEditComment = canAuthorEditComment;
var canAuthorSoftDeleteComment = function (comment, authorId) {
    if ((0, exports.isCommentModerated)(comment) || (0, exports.isCommentSoftDeleted)(comment))
        return false;
    return resolveCommentAuthorId(comment.author) === authorId;
};
exports.canAuthorSoftDeleteComment = canAuthorSoftDeleteComment;
/** One-level threading: top-level chronological; children under parent; accepted top-level first. */
var buildCommentThreads = function (comments, acceptedCommentId) {
    var _a;
    var topLevel = comments.filter(function (c) { return !c.parentCommentId; });
    var repliesByParent = new Map();
    for (var _i = 0, comments_1 = comments; _i < comments_1.length; _i++) {
        var comment = comments_1[_i];
        if (!comment.parentCommentId)
            continue;
        var list = (_a = repliesByParent.get(comment.parentCommentId)) !== null && _a !== void 0 ? _a : [];
        list.push(comment);
        repliesByParent.set(comment.parentCommentId, list);
    }
    var sortByCreated = function (a, b) { var _a, _b; return new Date((_a = a.createdAt) !== null && _a !== void 0 ? _a : 0).getTime() - new Date((_b = b.createdAt) !== null && _b !== void 0 ? _b : 0).getTime(); };
    var orderedTop = (0, exports.orderTopicComments)(topLevel, acceptedCommentId);
    return orderedTop.map(function (comment) {
        var _a;
        return (__assign(__assign({}, comment), { replies: ((_a = repliesByParent.get(comment._id)) !== null && _a !== void 0 ? _a : []).sort(sortByCreated).map(function (reply) { return (__assign(__assign({}, reply), { replies: [] })); }) }));
    });
};
exports.buildCommentThreads = buildCommentThreads;
var commentLikeCount = function (likes) {
    if (Array.isArray(likes))
        return likes.length;
    if (typeof likes === 'number' && Number.isFinite(likes))
        return likes;
    return 0;
};
exports.commentLikeCount = commentLikeCount;
var orderTopicComments = function (comments, acceptedCommentId) {
    if (!acceptedCommentId)
        return comments;
    var accepted = comments.filter(function (comment) { return comment._id === acceptedCommentId; });
    var rest = comments.filter(function (comment) { return comment._id !== acceptedCommentId; });
    return __spreadArray(__spreadArray([], accepted, true), rest, true);
};
exports.orderTopicComments = orderTopicComments;
var mostLikedCommentId = function (comments) {
    var bestId = null;
    var bestCount = 0;
    for (var _i = 0, comments_2 = comments; _i < comments_2.length; _i++) {
        var comment = comments_2[_i];
        if ((0, exports.isCommentModerated)(comment))
            continue;
        var count = (0, exports.commentLikeCount)(comment.likes);
        if (count > bestCount) {
            bestCount = count;
            bestId = comment._id;
        }
    }
    return bestCount > 0 ? bestId : null;
};
exports.mostLikedCommentId = mostLikedCommentId;
var topicNeedsHelpfulMark = function (post) {
    var comments = Array.isArray(post.comments) ? post.comments : [];
    return comments.length > 0 && !post.acceptedCommentId;
};
exports.topicNeedsHelpfulMark = topicNeedsHelpfulMark;
//# sourceMappingURL=forumComments.js.map